// TODO 以后如果方法多了，要做文件拆分
// @ts-ignore
import MD5 from "crypto-js/md5";
export const getMD5Encode = (data) => MD5(data).toString();
